import * as STD                                         from '@emersya/mpa-std-lib';
import CM                                               from '@emersya/mpa-components-manager-lib';

export interface IInputValue {
	min : number;
	default : number;
	max : number;
};

export interface IInputMinDefaultMaxComponentConfiguration extends IInputComponentConfiguration<
	IInputValue,
	IInputValue
>
{
};

export class InputMinDefaultMaxComponent extends InputComponent<
	HTMLDivElement,
	IInputValue,
	IInputValue,
	InputMinDefaultMaxComponent,
	IInputMinDefaultMaxComponentConfiguration
>
{
	component_DOM : HTMLDivElement;

	override deserialize(x : IInputValue) {
		return (x);
	};

	async reset() {
		await this.updateValue(this.component_configuration.defaultValue || null);
	};

	override isValueTheDefault() {
		return (!!(
			this.value &&
			this.defaultValue &&
			(this.value.min === this.defaultValue.min) &&
			(this.value.default === this.defaultValue.default) &&
			(this.value.max === this.defaultValue.max)
		));
	};

	serialize() {
		return this.value;
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IInputMinDefaultMaxComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});
	};
};
export namespace NS {
	export const Component = InputMinDefaultMaxComponent;
	export type Component = InputMinDefaultMaxComponent;
	export type Configuration = IInputMinDefaultMaxComponentConfiguration;
}
;
import manifestXMLSource                                from './InputMinDefaultMax.xml';
import './InputMinDefaultMax.scss';
import { InputComponent, IInputComponentConfiguration } from '../Input/Input';

CM.declare({
	id :       'input-min-default-max',
	type :     InputMinDefaultMaxComponent,
	manifest : manifestXMLSource
});
